import React from 'react';
import BackButton from './BackButton';
import TreasuryAssetImage from './images/AntCoin.png';

function TreasuryAsset({ antCoinBalance, antCoinWeight, antCoinPrice, formattedTotalValue }) {


    return (
        <div className="inventory-container-right" id="treasury-right">
            <div className="treasury-header">
                <img src={TreasuryAssetImage} alt="ANT Coin" />
                <h2>ANT Coin</h2>
                <p>Official currency of the Kingdom of ANTS</p>
            </div>
            <div className="treasury-stats">
                <div className="stats-container"><h3>Weight</h3><h2>{(antCoinWeight)}</h2></div>
                <div className="stats-container"><h3>Price</h3><h2>${(antCoinPrice)}</h2></div>
                <div className="stats-container"><h3>Total Amount</h3><h2>{antCoinBalance.toLocaleString()}</h2></div>
                <div className="stats-container"><h3>Total Value</h3><h2>${(formattedTotalValue)}</h2></div>
            </div>
        </div>
    );
}

export default TreasuryAsset;